<div class="footer container-fluid">
	<div class="row text-center footer_bg bg-primary_7">
		<div class="col-6 text-end">
			<div class="footer_top-content d-flex my-4 me-5">
				<img src="assets/img/footer-logo.svg" class="footer_top-content_logo-img" alt="لوگوی همساز هیوا">
				<span class="col-3 font-M2-lg font-M2-md font-M2-sm bold">سازمان صنایـــع کوچک و شهرک های صنعتی ایران</span>
			</div>
			<div class="footer_bottom-content me-5">
				<span>
						شركت شهركهای صنعتی استان هم‌اکنون به عنوان یکی از شرکتهای زیرمجموعه
						سازمان صنایع کوچک و شهرکهای صنعتی ایران با تحت پوشش داشتن 14 شهرك صنعتي مصوب و 2 منطقه ويژه اقتصادی و 19 ناحیه صنعتی 
						به خدمات خود ادامه مي دهد و با ايجاد زير ساختهای لازم منجر
						به حدود 30000 فرصت شغلی در استان گردیده است. این شرکت در حوزه معاونت صنایع کوچک، اقدامات ویژه ای برای توانمندسازی
						مدیریت و کارکنان واحدهای صنعتی، حسب درخواست انجمنها و یا شرکتهای تخصصی خدمات دهنده در این حوزه انجام میدهد.
					</span>
			</div>
			<div class="footer_address me-5">
				<span>آدرس:</span>
				<span class="me-2">تهران، بزرگراه کردستان، خیابان عطار، خیابان نیروی انتظامی، پلاک ۱۰</span>
			</div>
			<div class="footer_mail me-5 my-3">
				<span>ایمیل:</span>
				<!-- <span class="me-2">info@isipo.ir</span> -->
			</div>
			<div class="footer_social-media me-5 mb-5">
				<div
					class="footer_social-media_whatsapp footer_social-media_bg-style bg-primary d-flex align-items-center justify-content-center bg-primary">
					<div
						class="footer_social-media_bg-style_inner-div bg-muted_0 d-flex align-items-center justify-content-center ">
						<i class="isax icon-whatsapp primary_7"></i>
					</div>
				</div>
				<div
					class="footer_social-media_instagram footer_social-media_bg-style bg-primary d-flex align-items-center justify-content-center bg-primary">
					<div
						class="footer_social-media_bg-style_inner-div bg-muted_0 d-flex align-items-center justify-content-center ">
						<i class="isax icon-instagram primary_7"></i>
					</div>
				</div>
				<div class="footer_social-media_phone ">
					<div class="footer_social-media_phone_phone-number ms-2">
						<span class="footer_social-media_phone_phone-number_code primary">021</span>
						<span class="footer_social-media_phone_phone-number_number muted_0">88770921</span>
					</div>
					<div
						class=" footer_social-media_bg-style bg-primary d-flex align-items-center justify-content-center bg-primary">
						<div
							class="footer_social-media_bg-style_inner-div bg-muted_0 d-flex align-items-center justify-content-center ">
							<i class="isax icon-mobile primary_7"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-6 text-start footer_left-content">
			<div class="row">
				<div class="col-2 text-end d-flex flex-column">
					<span class="font-M2-lg font-M2-md font-M2-sm bold mt-5">
						لینک‌های مفید
					</span>
					<span class="my-3">
						<a href="#!">نمایشگاه‌ها</a>
					</span>
					<span>
						<a href="#!">سوالات متداول</a>
					</span>
					<span class="my-3">
						<a href="#!">درباره ما</a>
					</span>
					<span>
						<a href="#!">تماس با ما</a>
					</span>
				</div>
				<div class="col-4  text-end d-flex flex-column">
					<span class="mt-5 font-M2-lg font-M2-md font-M2-sm bold">
						خدمات ما
					</span>
					<span class="my-3">
						<a (click)="goToProductionUnit()">ثبت واحد دریافت کننده خدمات</a>
					</span>
					<span>
						<a (click)="goToBdspUnit()">ثبت واحد ارائه دهنده خدمات</a>
					</span>
				</div>
				<div class="col-6">
					<span class="d-flex mt-5 font-M2-lg font-M2-md font-M2-sm bold">از آخرین نمایشگاه ها، اخبار و رویداد ‌های ما
						مطلع شوید:</span>
					<div class="footer_left-content_input">
						<ms-form class="mt-3" [widgetOption]="emailInput"></ms-form>
						<!-- <app-button-loader [button]="submit"></app-button-loader> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="notify muted_0 bg-primary_8">
	© تمامی حقوق این وب سایت محفوظ و متعلق به شرکت شهرک‌های صنعتی استان یزد است.
</div>